import MemberRegisterNSModal from './MemberRegisterNSModal';
export default MemberRegisterNSModal;
